import * as React from 'react';
import { Event } from '../../../../../types';
import './RadioQuestion.css';

interface Props {
    selected: string;
    question: string;
    index: number;
    onChange: (e: Event) => void;
}

class RadioQuestion extends React.Component<Props> {
    render() {
        const { selected, onChange, question, index } = this.props;
        const questionId = `question${index}`;
        const checked = selected === questionId;

        return (
            <div className="radio-flex-container">
                <input
                    className="radio-flex-input"
                    type="radio"
                    id={questionId}
                    name="data"
                    checked={checked}
                    onChange={onChange}
                />
                <label htmlFor={questionId}> {question}</label>
            </div>
        );
    }
}

export default RadioQuestion;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/sections/RadioQuestion.tsx